<h3>{{ ( (page === 'privacy') ? "legal.privacyTitle" : "legal.legalTermsTitle") | translate }}</h3>

<div class="legal-container"
     [innerHTML]="((page === 'terms')? 'legal.legalTextWeb' : 'legal.privacyTextWeb' ) | translate">
</div>
